/*global _ */
import Base from '../../../Base'
import Transformer from './Transformer'

export class Image extends Base {
  constructor(data, vm) {
    super(data, vm)
    this.init(data, vm)
  }

  get id() {
    return this.$$data.id
  }

  get transformer () {
    let service = this.$$transformer
    if (!service) {
       service = this.$$transformer =  new Transformer({
         $$parent: this
       }, this.$$vm)
    }
    return service
  }
  applyFilters(filters) {
    //@todo
  }

  applyDropShadow(options = {}, config = {}) {
    return this.transformer.dropShadow(options, config)
  }

  init(data, vm) {
    const image = this.$$image = data.image

    if (image) {
      if (this.hasLoaded(image)) {
        this.$$loadedImage = image
      } else {
        image.onload = () => {
          this.$$loadedImage = image
        }
      }
    }
  }

  hasLoaded(image) {
    image = image || this.$$image
    return image.complete
  }

  hasLoadedImage(image) {
    image = image || this.$$image
    return this.hasLoaded(image) && image.naturalHeight !== 0
  }
}

Image.Transformer = Transformer

export default Image
